import { render } from "./Tab1Page.vue?vue&type=template&id=14cc4e2f"
import script from "./Tab1Page.vue?vue&type=script&lang=js"
export * from "./Tab1Page.vue?vue&type=script&lang=js"

import exportComponent from "/Users/timtsang/VueProject/test-2-2/test-2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__